/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Panel_Dispatch_ButtonInputs */

const en_tasks_panel_dispatch_button = /** @type {(inputs: Tasks_Panel_Dispatch_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New task`)
};

const fr_tasks_panel_dispatch_button = /** @type {(inputs: Tasks_Panel_Dispatch_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle tâche`)
};

const ms_sg2_tasks_panel_dispatch_button = /** @type {(inputs: Tasks_Panel_Dispatch_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan baru`)
};

/**
* | output |
* | --- |
* | "New task" |
*
* @param {Tasks_Panel_Dispatch_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_panel_dispatch_button = /** @type {((inputs?: Tasks_Panel_Dispatch_ButtonInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Panel_Dispatch_ButtonInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_panel_dispatch_button(inputs)
	if (locale === "fr") return fr_tasks_panel_dispatch_button(inputs)
	return ms_sg2_tasks_panel_dispatch_button(inputs)
});